import axios from 'axios';
import { ShowToast, toastType } from './toast-service';
import { API_HEADERS, API_URL } from '../constants/api';
import commonLabels from '../constants/messageConstants';
import store from '../store/appStore';
import * as actionType from '../store/layout/actionTypes';
import * as loaderActionType from '../store/loader/actionTypes';
import * as LocalCacheActionType from '../store/localCache/actionTypes';
import { authenticationSilentParameters, authProvider } from '../authProvider';
import 'regenerator-runtime/runtime';
import { getTokenLastFetchedData, SPSToken, setSPSToken, getSPSTokenData, getLastFetchedSPSTokenData } from '../constants/appConstants';
import _ from 'lodash';
import { generateString, setDownloadingStatus } from './generic';

function diffInMinutes(dt2, dt1) {
  let diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return (Math.round(diff));
}
function getHeaders() {
  // authProvider.acquireTokenSilent(authenticationParameters).then(AuthResponse => {
  //   console.log(AuthResponse);
  //   // const result = {
  //   //   authorization: `${API_HEADERS.authName} ${token.accessToken}`,
  //   //   cloudOrgId: 1
  //   // };
  //   // //return resolve(result);
  // });
  return new Promise(function (resolve, reject) {
    // if (authProvider &&
    //   authProvider.account &&
    //   authProvider.account.idTokenClaims &&
    //   authProvider.account.idTokenClaims.exp) {
    //   const expiration = new Date(new Date(0).setUTCSeconds(authProvider.account.idTokenClaims.exp));
    //   const dateToCompare = new Date();
    //   const diff = diffInMinutes(dateToCompare, expiration);
    //   // console.log('expiration', expiration);
    //   if (diff < -20 || diff > 5) {
    //     return resolve({
    //       authorization: `${API_HEADERS.authName} ${localStorage.getItem(API_HEADERS.authToken)}`,
    //       cloudOrgId: 1
    //     });
    //   }
    // }
    const fetchedDate = getTokenLastFetchedData();
    if (fetchedDate === null || diffInMinutes(new Date(), fetchedDate) > 2) {
      authProvider.acquireTokenSilent(authenticationSilentParameters)
        .then(token => {
          const result = {
            authorization: `${API_HEADERS.authName} ${token.idToken.rawIdToken}`,
            cloudOrgId: 1
          };
          // console.log('accquired new token', result);
          localStorage.setItem(API_HEADERS.authToken, token.idToken.rawIdToken);
          return resolve(result);
        }).catch((err) => {
          console.log(err);
          return resolve({
            authorization: `${API_HEADERS.authName} ${localStorage.getItem(API_HEADERS.authToken)}`,
            cloudOrgId: 1
          });
        });
    } else {
      return resolve({
        authorization: `${API_HEADERS.authName} ${localStorage.getItem(API_HEADERS.authToken)}`,
        cloudOrgId: 1
      });
    }
  });
}

function getSpsHeaders() {
  return new Promise(function (resolve, reject) {
    const spsToken = getSPSTokenData();
    const fetchedDate = getLastFetchedSPSTokenData();
    if (fetchedDate === null || diffInMinutes(new Date(), fetchedDate) > 10 || spsToken === null) {
      apiRequest({ url: API_URL.Users.AcquireSPToken }).then(
        ({ updateData }) => {
          if (updateData) {
            setSPSToken(updateData);
            return resolve({
              authorization: `${API_HEADERS.authName} ${updateData}`,
              cloudOrgId: 1,
              sps: 1
            });
          } else {
            return resolve({
              authorization: `${API_HEADERS.authName} ${spsToken}`,
              cloudOrgId: 1,
              sps: 1
            });
          }
        }
      );
    } else {
      return resolve({
        authorization: `${API_HEADERS.authName} ${spsToken}`,
        cloudOrgId: 1,
        sps: 1
      });
    }
  });
}

function getToken() {
  return new Promise(function (resolve, reject) {
    authProvider.getAccessToken().then(token => {
      localStorage.setItem(API_HEADERS.authToken, token.accessToken);
      const result = {
        authorization: `${API_HEADERS.authName} ${token.accessToken}`,
        cloudOrgId: 1
      };
      return resolve(result);
    }).catch(() => {
      return resolve({
        authorization: `${API_HEADERS.authName} ${localStorage.getItem(API_HEADERS.authToken)}`,
        cloudOrgId: 1
      });
    });
  });
}
// cloudOrgId: localStorage.getItem(
//   API_HEADERS.CID
// )

axios.interceptors.request.use(
  (config) => {
    store.dispatch({
      type: actionType.CLEAR_ERROR_PAGE,
      payload: null
    });
    if (config.headers.async === undefined) {
      store.dispatch({
        type: loaderActionType.SET_VISIBILITY,
        payload: true
      });
    }
    return config;
  },
  (error) => {
    // console.log("Request was sent", error);
    return Promise.reject(error.response);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response.config.headers.async === undefined) {
      store.dispatch({
        type: loaderActionType.SET_VISIBILITY,
        payload: false
      });
    }
    // console.log("response received", response);
    return response;
  },
  (error) => {
    store.dispatch({
      type: loaderActionType.SET_VISIBILITY,
      payload: false
    });
    // console.log("response received", error);
    if (error.message === 'Network Error') {
      store.dispatch({
        type: actionType.SET_ERROR_PAGE,
        payload: commonLabels.serverError
      });
    }

    if (error.response) {
      if (error.response.status === 401 && response.config.headers.sps !== 1) {
        // console.log('logged out');
        // getToken();
        localStorage.removeItem('adal.idtoken');
        store.dispatch({
          type: actionType.SET_ERROR_PAGE,
          payload: commonLabels.sessionTimeOut
        });
      } else if (error.response.status === 403) {
        if (error.response.data.isValidImUser === false || error.response.data.hasAccessToSection === false) {
          // window.location = routes.unAuthorizedAccess;
          store.dispatch({
            type: actionType.SET_ERROR_PAGE,
            payload: commonLabels.unAuthorizedAccess
          });
          // return Promise.reject(error.response);
        } else {
          error.response.data.message =
            error.response.data.message +
            " You don't have permission to access this resource/ perform an action. Please contact site administrator or Helpdesk team.";
        }
      } else if (error.response.status === 400) {
        const error1 = error.response.data.title ? error.response.data.title : '';
        const error2 = error.response.data.message ? error.response.data.message : '';
        const error3 = error.response.data?.error?.message ? error.response.data?.error?.message : '';
        error.response.data = {
          message: error1 || error2 || error3 || 'Something went wrong...!'
        };
      } else if (error.response.status === 404) {
        if (((error.response && error.response.config && error.response.config.url) || '').indexOf('graph') === -1) {
          error.response.data = {
            message: 'The object referenced by the path does not exist.'
          };
        } else {
          error.response.data = {
            message: ''
          };
        }
      }
    }
    if ((error.config.url?.toLowerCase().indexOf('getpendingnotifications') > 0) === false) {
      errorHandler(error?.response?.data, error?.response?.status);
    }
    return Promise.reject(error?.response);
  }
);

export async function apiRequest({ url, params }) {
  const headers = await getHeaders();
  try {
    const responses = await axios.get(url, {
      headers,
      ...{ params }
    });
    return responses.data;
  } catch (e) {
    return {};
  }
}

export async function apiPost({ url, postBody, params }) {
  // debugger;
  const headers = await getHeaders();
  // headers.async = true;
  try {
    const { data } = await axios.post(url, postBody, {
      headers,
      ...{ params }
    });
    return { data, success: data.success };
  } catch (e) {
    return { success: statusHandler(400), data: {} };
  }
}
const localStore = [];
let currentlyExecuting = [];

async function getDataFromStore(url, params, headers, duration = 1) {
  return new Promise(function (resolve, reject) {
    const key = url + JSON.stringify(params);
    if (currentlyExecuting.find(x => x.key === key) === undefined && getCachedData(key) === undefined) {
      currentlyExecuting.push({ key: key });
      axios.get(url, {
        headers,
        ...{ params }
      }).then((responses) => {
        localStore.push({ key: key, data: responses.data });
        store.dispatch({
          type: LocalCacheActionType.SET_CACHE_DATA,
          payload: { key: key, data: responses.data }
        });

        // setTimeout(({ key }) => {
        //   store.dispatch({
        //     type: LocalCacheActionType.CLEAR_CACHE_DATA_BY_KEY,
        //     payload: key
        //   });
        // }, duration * 60 * 1000);
        setTimeout((data) => {
          data && store.dispatch({
            type: LocalCacheActionType.CLEAR_CACHE_DATA_BY_KEY,
            payload: data.key
          });
        }, duration * 60 * 1000);

        currentlyExecuting = currentlyExecuting.filter(x => x.key !== key);
        return resolve(_.cloneDeep(responses.data));
      });
    } else {
      return resolve(waitFor(getCachedData, key));
    }
  }
  );
}

async function waitFor(f, key) {
  let r = f(key);
  while (!r) {
    // console.log('Not yet, waiting more');
    await delay(500);
    r = f(key);
  }
  return _.cloneDeep(r.data);
}
function delay(delay) {
  return new Promise((resolve, reject) => setTimeout(resolve, delay));
}

function getCachedData(key) {
  return (((store.getState() || {}).localCache || {}).cachedData || []).find(x => x.key === key);
}

export async function apiRequestNoLoadder({ url, params, fromCache = false, duration = 1 }) {
  const headers = await getHeaders();
  headers.async = true;
  try {
    if (fromCache === true) {
      return getDataFromStore(url, params, headers, duration);
    }
    const responses = await axios.get(url, {
      headers,
      ...{ params }
    });

    return responses.data;
  } catch (e) {
    return {};
  }
}

export async function apiBatchRequest(apiList) {
  const apiAxiosArr = [];
  const headers = await getHeaders();
  // const data = await Promise.all(
  //   apiList.map(({ url, params }) =>
  //     axios.get(url, {
  //       headers,
  //       ...{ params }
  //     })));
  const cachedResponse = {};
  const cachedRequest = [];
  const nonCachedRequest = [];
  const cachedRequestKey = [];
  apiList.forEach(({ url, params, key, fromCache = false, duration = 10 }) => {
    if (fromCache === false) {
      apiAxiosArr.push(
        axios.get(url, {
          headers,
          ...{ params }
        })
      );
      nonCachedRequest.push({ key: key });
    } else {
      cachedRequest.push(getDataFromStore(url, params, headers, duration));
      cachedRequestKey.push(key);
    }
  });

  const response = genericAPI(apiAxiosArr, nonCachedRequest);
  const arrayResponse = await Promise.all(cachedRequest);
  arrayResponse.forEach((x, i) => {
    cachedResponse[cachedRequestKey[i]] = x;
  });
  const result = await response;
  return { ...result, ...cachedResponse };
}

function genericAPI(apiAxiosArr, apiList) {
  const responseData = {};
  return axios
    .all(apiAxiosArr)
    .then(
      axios.spread((...responses) => {
        responses.forEach((res, i) => {
          responseData[apiList[i].key] = res.data;
        });

        return responseData;
      })
    )
    .catch(({ response }) => {
      // errorHandler(response);
      return response;
    });
}

export async function apiPut(url, postBody, params) {
  const headers = await getHeaders();
  try {
    const { data, status } = await axios.put(url, postBody, {
      headers,
      ...{ params }
    });
    return { data, success: statusHandler(status) };
  } catch (e) {
    return { success: statusHandler(400), data: {} };
  }
}

export async function apiPostNoLoader({ url, postBody, params }) {
  const headers = await getHeaders();
  headers.async = true;
  try {
    const { data } = await axios.post(url, postBody, {
      headers,
      ...{ params }
    });
    return { data, success: data.success };
  } catch (e) {
    return { success: statusHandler(400), data: {} };
  }
}

export async function apiDelete({ url, params }) {
  const headers = await getHeaders();
  const response = await axios.delete(url, {
    headers,
    ...{ params }
  });
  return response;
}

function errorHandler(response, code) {
  if (!response) return;
  const errorMsg1 = response?.message ? response.message : '';
  const errorMsg2 = response?.error && response.error?.message ? response.error.message : '';

  if (errorMsg1 === 'Name already exists' || errorMsg2 === 'Name already exists' ||
    errorMsg1 === 'The specified item name already exists.' || errorMsg2 === 'The specified item name already exists.') {

  } else {
    ShowToast(errorMsg1 || errorMsg2, toastType.ERROR, 5000, code);
  }
}

function statusHandler(status) {
  if (!status) return;
  switch (status) {
    case 200:
      return true;

    default:
      return false;
  }
}

export async function getSpsAPiRequest(url) {
  const spsHeaders = await getSpsHeaders();
  return axios
    .get(url, {
      headers: spsHeaders
    })
    .then(responses => {
      return responses.data;
    })
    .catch(data => {
      return data;
    });
}

export async function spsApiPost({ url, postBody, params }) {
  const spsHeaders = await getSpsHeaders();
  return axios
    .post(url, postBody, {
      headers: spsHeaders,
      ...{ params }
    })
    .then(({ data, status }) => {
      return { data, success: statusHandler(status) };
    })
    .catch(({ error }) => {
      // return { success: statusHandler(400), data: {} };
    });
}

export async function uploadSpsAPiRequest(url, file, isAddContent = false) {
  let spsHeaders = await getSpsHeaders();
  spsHeaders = {
    ...spsHeaders,
    ...(isAddContent && {
      'Content-Length': file.size,
      'Content-Range': `bytes 0-${file.size - 1}/${file.size}`
    })
  };
  return axios
    .put(url, file, {
      headers: spsHeaders
    })
    .then(responses => {
      return responses.data;
    })
    .catch(({ response }) => {
      return response;
    });
}

export async function uploadSpsMetadataAPiRequest(url, metadata) {
  const spsHeaders = await getSpsHeaders();
  return axios
    .patch(url, metadata, {
      headers: spsHeaders
    })
    .then(responses => {
      this.props.getSpsData();
      return responses.data;
    })
    .catch(({ response }) => {
      return response;
    });
}

export async function deleteSpsApiRequest(url) {
  const spsHeaders = await getSpsHeaders();
  return axios
    .delete(url, {
      headers: spsHeaders
    })
    .then(responses => {
      // this.props.getSpsData();
      // response.statusText: "No Content";
      return true;
    })
    .catch(error => {
      console.log(error, 'Delete API');
      // error.statusText: "Not Found"
      return true;
    });
}

export function downloadReport(
  reportAbsoluteURL,
  fileName = 'Report.xls',
  fileMimeType = 'application/vnd.ms-excel',
  type,
  isPrint = false
) {
  //const extention = type === 'Excel' ? '.xls' : '.pdf';
  fileMimeType = fileMimeType = 'application/vnd.ms-excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': fileMimeType;
  const extention = type === 'Excel' ? '.xlsx' : '.pdf';
  const uploadingKey = generateString(6);
  if (!isPrint) {
    const msgId = type === 'Excel' ? 501 : 502;
    fileName = fileName + extention;
    // ShowToast(
    //   'Report download is in progress. We will notify you once ' + fileName + ' [' + extention + '] is downloaded.',
    //   toastType.INFO,
    //   5000,
    //   msgId
    //   //,'Report Download In Progress'
    // );
    setDownloadingStatus(
      uploadingKey,
      fileName,
      'downloading',
      '',
      'Report Download In Progress'
    );
  } else {
    fileName = fileName + extention;
    setDownloadingStatus(
      uploadingKey,
      fileName,
      'downloading',
      '',
      'Report Download for Print In Progress'
    );
  }

  const postBody = {
    AbsoluteUri: reportAbsoluteURL,
    FileMimeType: fileMimeType,
    FileDownloadName: fileName
  };
  const spsHeaders = {
    headers: { 'Content-Type': 'application/json' }
  };
  spsHeaders.async = true;
  axios
     .post('https://streamdatum-ultipro-apis.azurewebsites.net/api/v1/SSRSReport/GenerateReport', postBody, {
     //.post('https://streamdatum-ultipro-prod-apis.azurewebsites.net/api/v1/SSRSReport/GenerateReport', postBody, {
      method: 'POST',
      headers: spsHeaders,
      responseType: 'blob', // Force to receive data in a Blob Format
      timeout: (15*60*1000)
    })
    .then(response => {
      const fileUrl = window.URL.createObjectURL(response.data);

      if (isPrint) {
        window.open(window.location.origin + '/fileViewer?url=' + fileUrl, '_blank');
        setDownloadingStatus(
          uploadingKey,
          fileName,
          'completed',
          '',
          'Report is ready to print'
        );
        return;
      }

      type = type === 'Excel' ? 'xlsx' : type;

      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = fileUrl;
      //a.download = fileName + '.' + type.toLowerCase();
      a.download = fileName;
      a.click();
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(fileUrl);
      }, 100);
      if (!isPrint) {
        const msgId = (type === 'xls' || type === 'xlsx' || type === 'Excel') ? 503 : 504;
        // const uploadingKey = generateString(6);
        // ShowToast(
        //   'Requested ' + fileName + ' [' + extention + '] has been downloaded successfully.',
        //   toastType.INFO,
        //   5000,
        //   msgId
        //   //, 'Report Downloading Completed'
        // );
        setDownloadingStatus(
          uploadingKey,
          fileName,
          'completed',
          '',
          'Report Downloading Completed'
        );
      }
    })
    .catch(({ error }) => {
      if (!isPrint) {
        const msgId = type === 'Excel' ? 501 : 502;
        fileName = fileName + extention;
        // ShowToast(
        //   'Report download is in progress. We will notify you once ' + fileName + ' [' + extention + '] is downloaded.',
        //   toastType.INFO,
        //   5000,
        //   msgId
        //   //,'Report Download In Progress'
        // );
        setDownloadingStatus(
          uploadingKey,
          fileName,
          'failed',
          '',
          'Report Downloading failed'
        );
      } else {
        fileName = fileName + extention;
        setDownloadingStatus(
          uploadingKey,
          fileName,
          'failed',
          '',
          'Report Downloading for Print is failed'
        );
      }
      return error;
    });
}
